import React from 'react';
import Kendra from 'aws-sdk/clients/kendra';
import { HighlightedText } from './HighlightedText';
import { isNullOrUndefined } from '../../facets/utils';
import { unionSortedHighlights } from 'src/components/kendra-search/utils';
import { generateUuid } from 'src/utils/uuid';
interface TextHighlightsProps {
    textWithHighlights: Kendra.TextWithHighlights;
}

export const TextHighlights = ({ textWithHighlights }: TextHighlightsProps) => {
    if (isNullOrUndefined(textWithHighlights)) {
        return null;
    }

    const text = textWithHighlights.Text;
    if (isNullOrUndefined(textWithHighlights.Highlights)) {
        return <span>{text}</span>;
    }

    // TopAnswer will be out of order, sort the highlights
    const sortedHighlights = unionSortedHighlights(
        textWithHighlights.Highlights!.sort(
            (highlight1: Kendra.Highlight, highlight2: Kendra.Highlight) =>
                highlight1.BeginOffset - highlight2.BeginOffset
        )
    );
    const lastHighlight = sortedHighlights[sortedHighlights.length - 1];
    const highlightKeys = sortedHighlights.map(() => generateUuid());

    return (
        <>
            {sortedHighlights.map(
                (highlight: Kendra.Highlight, idx: number) => (
                    <span key={highlightKeys[idx]}>
                        <span>
                            {text!.substring(
                                idx === 0
                                    ? 0
                                    : sortedHighlights[idx - 1].EndOffset,
                                highlight.BeginOffset
                            )}
                        </span>
                        <HighlightedText text={text} highlight={highlight} />
                    </span>
                )
            )}
            <span>
                {text!.substring(lastHighlight ? lastHighlight.EndOffset : 0)}
            </span>
        </>
    );
};
